export const JD_FIELDS = {
    job_title: {
        label: "Job Title",
        type: "TEXTAREA",
        required: true,
        minLength: 3,
        maxLength: 150,
    },

    company: {
        label: "Company",
        type: "ALPHANUMERIC",
        required: true,
        minLength: 2,
        maxLength: 150,
    },

    domain: {
        label: "Domain",
        type: "TEXTAREA",
        maxLength: 100,
    },

    job_type: {
        label: "Job Type",
        type: "TEXTAREA",
        maxLength: 100,
    },

    summary: {
        label: "Job Description",
        type: "TEXTAREA",
        required: true,
        minLength: 100,
        maxLength: 5000,
    },

    responsibilities: {
        label: "Responsibilities",
        type: "TEXTAREA",
        required: true,
        minLength: 50,
        maxLength: 3000,
    },

    qualifications: {
        label: "Qualifications",
        type: "TEXTAREA",
        required: true,
        minLength: 2,
        maxLength: 2000,
    },

    keySkills: {
        label: "Key Skills",
        type: "TEXTAREA",
        required: true,
        minLength: 3,
        maxLength: 2000,
    },

    additionalSkills: {
        label: "Additional Skills",
        type: "TEXTAREA",
        minLength: 3,
        maxLength: 2000,
    },
};